import { useContext, useCallback } from "react";
import { SwiperContext } from "../SwiperContext";

export const useSwiperControl = () => {

  const swiperContext = useContext(SwiperContext);
  const { swiper_state, swiper_handlers } = swiperContext ?? {};
  const swiper = swiper_state?.swiperRef?.current ?? swiper_state?.swiperRef;

  const lockSwiper = useCallback(() => {
    swiper_handlers && swiper_handlers.handleSwipe_disable();
  }, [swiper_handlers]);

  const unlockSwiper = useCallback(() => {
    swiper_handlers && swiper_handlers.handleSwipe_enable();
  }, [swiper_handlers]);

  return { lockSwiper, unlockSwiper, swiper };
};
